<template>
  <div>
    <div
      v-if="
        limsds_userDetails.userEmail != null &&
        limsds_userDetails.userEmail != ''
      "
    >
      <v-form v-show="ParentComponent">
        <v-row dense>
          <v-col sm="1" class="InstructionsBold">Step 1: </v-col>
          <v-col sm="10" class="Instructions">Search for sample points </v-col>
          <v-col align="Right" sm="1">
            <v-menu open-on-hover top offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="orange" small v-bind="attrs" v-on="on"
                  >mdi-help</v-icon
                >
              </template>

              <v-list>
                <v-list-item>
                  <a
                    :href="HelpSearchByPoint"
                    title="About This Page"
                    target="limsds_help"
                    >About This Page</a
                  ></v-list-item
                >
                <v-list-item
                  ><a
                    :href="NewsLetter"
                    title="Newsletter Index"
                    target="limsds_help"
                    >Newsletter Index</a
                  ></v-list-item
                >
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-checkbox
              v-model="defaultValues.onlySamplesPreviousYear"
              dense
              hide-details
              :label="`Only include unit, area and product selections for samples that have been collected in the previous year`"
            ></v-checkbox> </v-col
        ></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              solo
              hide-details
              dense
              label="Select Site"
              v-model="list.site1"
              @input="FillUnitDropDown"
              :items="defaultValues.SiteList"
              item-text="site"
              item-value="site"
            ></v-select> </v-col
        ></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              label="Select Unit"
              v-model="defaultValues.SelectedUnit"
              @input="FillAreaDropDown"
              :items="defaultValues.UnitList"
              solo
              hide-details
              dense
              item-text="UnitName"
              item-value="UnitValue"
            ></v-select> </v-col
        ></v-row>
        <v-row dense>
          <v-col sm="3">
            <v-select
              solo
              hide-details
              dense
              label="Select Area"
              v-model="defaultValues.SelectedArea"
              :items="defaultValues.AreaList"
              item-text="AreaName"
              item-value="AreaID"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1">
            <v-select
              solo
              hide-details
              dense
              label="Sample Point"
              v-model="defaultValues.DDSamplePoint"
              :items="defaultValues.itemsCommonDD"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="3">
            <v-text-field
              v-model="defaultValues.SamplePoint"
              dense
              solo
              hide-details
              label="Sample Points"
            ></v-text-field> </v-col
        ></v-row>
        <v-row dense>
          <v-col sm="1">
            <v-select
              label="Sample Description"
              v-model="defaultValues.DDSampleDesc"
              dense
              solo
              hide-details
              :items="defaultValues.itemsCommonDD"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="3">
            <v-text-field
              v-model="defaultValues.SampleDesc"
              dense
              solo
              hide-details
              label="Sample Description"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="2">
            <v-btn
              dense
              solo
              rounded
              hide-details
              color="primary"
              dark
              @click="FetchSamplePoints()"
              >Get Search
            </v-btn>
          </v-col>
          <v-col sm="2">
            <v-btn
              rounded
              solo
              hide-details
              color="primary"
              dark
              dense
              @click="ResetFilter()"
              >Reset Search Fields
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1" class="InstructionsBold">Step 2: </v-col>
          <v-col sm="11" class="Instructions"
            >Select Sample Points to be included in results, repeat Step 1 to
            search and select additional Sample Points
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="8" class="InstructionsBold">
            Available Sample Points
          </v-col></v-row
        >
        <v-row dense>
          <v-col sm="8">
            <v-data-table
              dense
              v-model="SelectedSampleListResult"
              :headers="Resultheaders"
              :items="SampleListResult"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 20],
              }"
              :items-per-page="list.Rowsinresulttable"
              item-key="d_key"
              :loading="isLoading"
              loading-text="Loading... Please wait"
              show-select
            >
            
            </v-data-table
          ></v-col>
        </v-row>
        <v-row dense>
          <v-col sm="2" class="InstructionsBold">
            Selected Sample Points 
          </v-col>
          <v-col sm="5" align="right">
             <v-btn rounded 
              solo
              hide-details
              color="primary"
              dark
              dense @click="DeleteItemResult">Delete All</v-btn>
          </v-col></v-row
        >
        <v-row dense>
          <v-col sm="8">
            <v-data-table
              dense
              :headers="ResultheaderAction"
              :items="SelectedSampleListResult"
              item-key="d_key"
              :loading="isLoading"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 20],
              }"
              :items-per-page="list.Rowsinresulttable"
              loading-text="Loading... Please wait"
            >
              <!-- <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Selected Sample Points</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn @click="DeleteItemResult">Delete All</v-btn>
                </v-toolbar>
              </template> -->

              <template v-slot:item.actions="{ item }">
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1" class="InstructionsBold">Step 3: </v-col>
          <v-col sm="11" class="Instructions"
            >Enter date range and get result table, relative dates are accepted
            (0 is today, -7 is seven days in the past)
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <start-end-date-control
              :startDate.sync="dateValues.startDate"
              :endDate.sync="dateValues.endDate"
              :numIncSD.sync="dateValues.numIncSD"
              :numIncED.sync="dateValues.numIncED"
            ></start-end-date-control>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="2">
            <v-btn
              rounded
              solo
              dense
              hide-details
              color="primary"
              dark
              @click="FetchSampleListResult()"
              >Get Results
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <SearchByPointResult
        v-on:ShowFilterHideResult="ShowFilterHideResult($event)"
        v-if="ChildComponent"
        :userId="this.limsds_userDetails.userEmail"
        :XmlSamplePoints="this.XmlSamplePoints"
        :StartDate="this.dateValues.startDate"
        :EndDate="this.dateValues.endDate"
        :lims_internal="this.defaultValues.lims_internal"
      />
    </div>
    <div v-if="limsds_userDetails.userEmail == null">
      <h3>INVALID USER !!!</h3>
      <h4>Current user is not exist in system database !!!</h4>
    </div>
    <br />
  </div>
</template>
<script>
import SearchByPointResult from "./SearchByPointResult.vue";
import uiView from "@/_mixins/ui-view-mixin";
import appMixin from "../mixins/app-mixin";
import axios from "axios";
import startEndDateControl from "../components/startEndDateControl";
export default {
  name: "SearchByPoint",
  mixins: [uiView, appMixin],
  components: {
    SearchByPointResult,
    startEndDateControl,
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  created() {
    this.NewsLetter = this.settings.NewsLetter;
    this.HelpSearchByPoint = this.settings.HelpSearchByPoint;
    if (this.limsds_userDetails.userEmail != null) {
      this.list = this.limsds_userPreference;
      this.PrefSite = this.list.site1;
      this.FillSite();
      this.FillUnitDropDown(this.list.site1);
    }
  },

  mounted() {},
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      ChildComponent: false,
      ParentComponent: true,
      search: "",
      singleSelect: false,
      isLoading: false,
      list: [],
      XmlSamplePoints: {},
      SampleListResult: [],
      SelectedSampleListResult: [],
      dateValues: {
        numIncSD: "-7",
        numIncED: "0",
        startDate: null,
        endDate: null,
      },
      defaultValues: {
        SiteList: undefined,
        UnitList: undefined,
        AreaList: undefined,
        LabAreaList: undefined,
        SamplePointList: undefined,
        ProductList: undefined,
        onlySamplesPreviousYear: "1",
        lims_internal: "0",
        SelectedSite: null,
        SelectedUnit: null,
        SelectedArea: null,
        SelectedGroup: null,
        DDSamplePoint: 1,
        SamplePoint: "",
        SamplePointAPI: "%",
        DDProduct: 1,
        Product: "",
        ProductAPI: "%",
        DDSampleDesc: 1,
        SampleDesc: "",
        SampleDescAPI: "%",

        DDTest: 1,
        Test: "",
        TestAPI: "%",
        DDBatchID: 1,
        BatchID: "",
        BatchIDAPI: "%",
        DDMaterialNum: 1,
        MaterialNum: "",
        MaterialNumAPI: "%",
        DDMaterialDesc: 1,
        MaterialDesc: "",
        MaterialDescAPI: "%",
        DDComment: 1,
        Comment: "",
        CommentAPI: "%",
        SelectedLimitComp: "-1",
        itemsLimitComp: [
          { name: "No Preference", id: "-1" },
          { name: "Yes", id: "1" },
          { name: "No", id: "0" },
        ],
        itemsCommonDD: [
          { name: "Contains", id: 1 },
          { name: "Start With", id: 2 },
          { name: "Exact", id: 3 },
        ],
      },
      Resultheaders: [
        // { text: "D Key", value: "d_key", align: "start", sortable: false },
        { text: "Site", value: "site" },
        { text: "Sample Point", value: "point" },
        { text: "Description", value: "description" },
      ],
      ResultheaderAction: [
        // { text: "D Key", value: "d_key", align: "start", sortable: false },
        { text: "Site", value: "site" },
        { text: "Sample Point", value: "point" },
        { text: "Description", value: "description" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    FillSite() {
      let that = this;
      const SiteLink =
        that.settings.WASite + "UserID=" + that.limsds_userDetails.userEmail;
      axios.get(SiteLink).then((response) => {
        this.defaultValues.SiteList = response.data.enumSiteLists;
      });
    },
    DeleteItemResult() {
      this.SelectedSampleListResult = [];
    },
    deleteItem(item) {
      var editedIndex = this.SelectedSampleListResult.indexOf(item);
      if (confirm("Are you sure you want to delete this item?"));
      this.SelectedSampleListResult.splice(editedIndex, 1);
    },
    ShowFilterHideResult() {
      this.ParentComponent = true;
      this.ChildComponent = false;
    },
    FetchSampleListResult() {
      this.XmlSamplePoints = "<root>";
      this.XmlSamplePoints += this.SelectedSampleListResult.map((e) => {
        return `<sx site="${e.site}" d_key="${e.d_key}"/>`;
      }).join("");
      this.XmlSamplePoints += "</root>";

      this.ChildComponent = true;
      this.ParentComponent = false;
    },
    ResetFilter() {
      this.list.site1 = this.PrefSite;
      this.defaultValues.SelectedUnit = null;
      this.defaultValues.onlySamplesPreviousYear = "1";
      this.defaultValues.SelectedSite = null;
      this.defaultValues.SelectedUnit = null;
      this.defaultValues.SelectedArea = null;
      this.defaultValues.DDSamplePoint = 1;
      this.defaultValues.SamplePoint = "";
      this.defaultValues.SamplePointAPI = "%";
      this.defaultValues.DDSampleDesc = 1;
      this.defaultValues.SampleDesc = "";
      this.defaultValues.SampleDescAPI = "%";
    },
    hideResult() {
      if ((this.Show = false)) {
        this.Show = true;
      } else {
        this.Show = false;
      }
    },
    FetchSamplePoints() {
      this.isLoading = true;
      if (this.defaultValues.onlySamplesPreviousYear == false) {
        this.defaultValues.onlySamplesPreviousYear = "0";
      } else {
        this.defaultValues.onlySamplesPreviousYear = "1";
      }
      if (
        this.defaultValues.SelectedUnit == null ||
        this.defaultValues.SelectedUnit == undefined
      ) {
        this.defaultValues.SelectedUnit = "";
      }
      if (
        this.defaultValues.SelectedArea == null ||
        this.defaultValues.SelectedArea == undefined
      ) {
        this.defaultValues.SelectedArea = "";
      }

      if (
        this.defaultValues.DDSamplePoint == 1 &&
        this.defaultValues.SamplePoint != ""
      ) {
        this.defaultValues.SamplePointAPI =
          "%" + this.defaultValues.SamplePoint + "%";
      } else if (
        this.defaultValues.DDSamplePoint == 2 &&
        this.defaultValues.SamplePoint != ""
      ) {
        this.defaultValues.SamplePointAPI =
          "%" + this.defaultValues.SamplePoint;
      } else if (
        this.defaultValues.DDSamplePoint == 3 &&
        this.defaultValues.SamplePoint != ""
      ) {
        this.defaultValues.SamplePointAPI = this.defaultValues.SamplePoint;
      } else {
        this.defaultValues.SamplePointAPI = "%";
      }

      if (
        this.defaultValues.DDSampleDesc == 1 &&
        this.defaultValues.SampleDesc != ""
      ) {
        this.defaultValues.SampleDescAPI =
          "%" + this.defaultValues.SampleDesc + "%";
      } else if (
        this.defaultValues.DDSampleDesc == 2 &&
        this.defaultValues.SampleDesc != ""
      ) {
        this.defaultValues.SampleDescAPI = "%" + this.defaultValues.SampleDesc;
      } else if (
        this.defaultValues.DDSampleDesc == 3 &&
        this.defaultValues.SampleDesc != ""
      ) {
        this.defaultValues.SampleDescAPI = this.defaultValues.SampleDesc;
      } else {
        this.defaultValues.SampleDescAPI = "%";
      }

      const SampleListLink =
        this.settings.WASampleListWithDesc +
        "userid=" +
        this.limsds_userDetails.userEmail +
        "&Site=" +
        this.list.site1 +
        "&unit=" +
        this.defaultValues.SelectedUnit +
        "&area=" +
        this.defaultValues.SelectedArea +
        "&pointmask=" +
        this.defaultValues.SamplePointAPI +
        "&descmask=" +
        this.defaultValues.SampleDescAPI +
        "&lims_internal=" +
        this.defaultValues.lims_internal +
        "&earliest_date=2020-05-11 00:00:00";

      axios.get(SampleListLink).then((response) => {
        this.SampleListResult = response.data.value;
        console.log(this.SampleListResult);
      });
      this.isLoading = false;
    },
    FillUnitDropDown(value) {
      let that = this;
      const UnitLink =
        this.settings.WAUnit +
        "UserID=" +
        this.limsds_userDetails.userEmail +
        "&site=" +
        this.list.site1 +
        "&lims_internal=" +
        this.defaultValues.lims_internal +
        "&onlySamplesPreviousYear=" +
        this.defaultValues.onlySamplesPreviousYear;
      axios.get(UnitLink).then((response) => {
        that.defaultValues.UnitList = response.data.unitLists;
      });
    },
    FillAreaDropDown(value) {
      const AreaLink =
        this.settings.WAArea +
        "site=" +
        this.list.site1 +
        "&unit=" +
        this.defaultValues.SelectedUnit +
        "&onlySamplesPreviousYear=" +
        this.defaultValues.onlySamplesPreviousYear;
      axios.get(AreaLink).then((response) => {
        this.defaultValues.AreaList = response.data.areaListV2s;
      });
    },
  },
};
</script>
<style lang="scss">
.v-input input {
  max-height: 15px;
}
.row--dense > .col,
.row--dense > [class*="col-"] {
  padding: 2px;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 26px;
  min-width: 64px;
  padding: 0 10px;
}
</style>